window.lodash = require('lodash/index.js');
window.React = require('react/index.js');
